import { categoryTiles } from "@/mocks/data";

export default function Categories() {
  return (
    <section id="topics" className="relative w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">Topics</p>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">六大反差分类</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            按现象发生的场景与人群进行归类，收录日常讨论度最高的反差类型与对应素材。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
          {categoryTiles.map((c) => (
            <a
              key={c.name}
              href="#feed"
              className="group relative block overflow-hidden rounded-lg"
            >
              <div className="w-full overflow-hidden bg-background-200">
                <div className="aspect-[4/5] w-full">
                  <img
                    src={c.image}
                    alt={`${c.name}反差现象分类图`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-lg font-black text-background-50 md:text-xl">{c.name}</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-foreground-950">
                    {c.count}
                  </span>
                </div>
                <p className="mt-1.5 text-xs leading-relaxed text-background-100 opacity-90 md:text-sm">{c.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}